import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from '../../Context/store/context';
import { _get, _post, _put } from '../../../apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { _showToast } from "../../../toastHelper";
import { profilesList } from '../../Redux/Actions/ProfileListAction';
import globals from '../../../globals';
import { IconUpload } from "@tabler/icons-react";
import { uploadImage } from '../../Services/ImageService';
import ImageCropping from '../../Common/Image/ImageCropping';

export default function EditProfile() {
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const { showLoader, hideLoader, updateTitleAndIcon, getToken, logoutuser } = useAuth();
  const Navigate = useNavigate();
  const [profileId, setProfileId] = useState(0);
  const [logo, setLogo] = useState("/images/user3.png");
  const [studioName, setStudioName] = useState("");
  const [email, setEmail] = useState("");
  const [contactNo, setContactNo] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [locationUrl, setLocationUrl] = useState("");
  const [website, setWebsite] = useState("");
  const [facebook, setFacebook] = useState("");
  const [instagram, setInstagram] = useState("");
  const [youtube, setYoutube] = useState("");
  const [twitter, setTwitter] = useState("");
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [showCropperModal, setshowCropperModal] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [imageType, setImageType] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    if (!getToken())
      logoutuser();

  }, []);

  useEffect(() => {
    if (userDetails && id) {
      fetchStudioProfile(id);
    }
    if (!id) {
      updateTitleAndIcon(globals.addStudio.title, globals.addStudio.icon);
    } else
      updateTitleAndIcon(globals.editStudio.title, globals.editStudio.icon);

  }, [id, userDetails])



  const [emailError, setEmailError] = useState('');
  const [contactNoError, setContactNoError] = useState('');

  useEffect(() => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    if (email && !emailPattern.test(email)) {
      setEmailError('Invalid email address.');
    } else {
      setEmailError('');
    }
  }, [email]);

  useEffect(() => {
    const phoneNumberPattern = /^[6-9]\d{9}$/;
    if (contactNo && !phoneNumberPattern.test(contactNo)) {
      setContactNoError('Invalid contact number.');
    } else {
      setContactNoError('');
    }

  }, [contactNo]);

  const handleLogoChange = (event) => {
    showCropper(event, 'profile');
  };

  const showCropper = (event, type) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (validateFile(file)) {
        handleCropSave(event.target.files[0], '');
        // setImageType(type);
        // setImageFile(file);
        // setshowCropperModal(true);
      }
      else {
        document.getElementById("logoFileInput").value = null;
      }
    }
  }

  const validateFile = (file) => {
    let imageType = /image.*/;
    if (file && file.size > 1048576) {
      _showToast("Maximum file size allowed is 1MB, please try with different file.", "error");
      return false;
    }

    if (!file.type.match(imageType)) {
      _showToastt("File types with extension " + file.name.split('.').pop() + " are not supported.", "error");
      return false;
    }
    return true;
  }

  const fetchStudioProfile = async (profileId) => {
    showLoader();

    _get("/studio-profiles/" + profileId)
      .then((profile) => {

        if (profile.logo)
          setLogo(profile.logo);

        setProfileId(profile.id);
        setAddressLine1(profile.addressLine1);
        setAddressLine2(profile.addressLine2);
        setCity(profile.city);
        setContactNo(profile.contactNo);
        setCountry(profile.country);
        setEmail(profile.email);
        setFacebook(profile.facebook);
        setInstagram(profile.instagram);
        setLocationUrl(profile.locationUrl);
        setLocationUrl(profile.locationUrl);
        setPinCode(profile.pinCode);
        setState(profile.state);
        setStudioName(profile.studioName);
        setTwitter(profile.twitter);
        setWebsite(profile.website);
        setYoutube(profile.youtube);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
        return Navigate("/mystudios");
      })
  }

  const handleCropSave = (croppedImage, type) => {
    const file = croppedImage;
    const imageUrl = URL.createObjectURL(file);
    let container = new DataTransfer();
    container.items.add(file);
    setLogo(imageUrl);
    document.getElementById("logoFileInput").files = container.files;
    setshowCropperModal(false);
    setImageFile(null);
    setImageType(null);
  };

  const handleModalClose = () => {
    setshowCropperModal(false);
    document.getElementById("logoFileInput").value = null;
  };

  const handleSave = async (e) => {
    e.preventDefault();

    let validationErrors = {};
    if (!studioName) validationErrors.studioName = "Studio/Company name is required";
    if (!contactNo) validationErrors.contactNo = "Contact Number is required";
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;
    showLoader();

    let logoImageKey = "";
    if (document.getElementById("logoFileInput").files && document.getElementById("logoFileInput").files.length > 0) {
      if (await checkUploadStatus()) {
        logoImageKey = await uploadImage("logo", document.getElementById("logoFileInput").files[0], "", "StudioLogo");
      }
      else
        return;
    }

    if (await saveData(logoImageKey)) {
      await fetchStudioProfiles();
      hideLoader();
      return Navigate("/mystudios");
    }
  };

  const checkUploadStatus = async () => {
    return await _get(`/uploads/check-upload-status?eventCode=&imageCount=1&videoCount=0&studioProfileId=${profileId}`)
      .then((response) => {
        return true;
      })
      .catch((error) => {
        _showToast(error, "error");
        hideLoader();
        return false;
      });
  }


  const saveData = async (logoImageKey) => {
    let data = {
      "id": profileId,
      "studioName": studioName,
      "email": email,
      "contactNo": contactNo,
      "logoLocation": logoImageKey,
      "addressLine1": addressLine1,
      "addressLine2": addressLine2,
      "city": city,
      "state": state,
      "country": country,
      "pinCode": pinCode,
      "locationUrl": locationUrl,
      "website": website,
      "facebook": facebook,
      "instagram": instagram,
      "youtube": youtube,
      "twitter": twitter,
    }

    if (profileId > 0) {
      return await _put("/studio-profiles", data)
        .then((response) => {
          _showToast("Studio information updated successfully", "success");
          return true;
        }).catch(error => {
          hideLoader();
          _showToast(error, "error");
          return false;
        });
    }
    else {
      return await _post("/studio-profiles", data)
        .then((response) => {
          _showToast("Studio information saved successfully", "success");
          return true;
        }).catch(error => {
          hideLoader();
          _showToast(error, "error");
          return false;
        });
    }
  }

  const fetchStudioProfiles = async () => {
    await _get('/studio-profiles')
      .then((response) => {
        dispatch(profilesList(response));
      })
      .catch((error) => {
        _showToast(error, "error");
      });
  }

  const handleCancel = async (e) => {
    e.preventDefault();
    return Navigate("/mystudios");
  }

  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 container-p-y">
        <div className="card mb-4 pt-2">
          <div className="card-body">
            <form id="formAccountSettings" onSubmit={handleSave}>
              <div className="row">
                <div className="mb-3 col-md-6">
                  <div className="d-flex align-items-start align-items-sm-center gap-4">
                    <img src={logo} alt="user-avatar" className="d-block w-px-100 rounded" style={{ objectFit: "cover" }} />
                    <div className="button-wrapper">
                      <label htmlFor="logoFileInput" className="btn btn-primary me-2 mb-3" tabIndex="0">
                        <span>
                          <IconUpload size={22} className='me-1' />
                          Upload Studio Logo
                        </span>
                        <input type="file" id="logoFileInput" className="account-file-input" hidden accept="image/png, image/jpeg" onChange={handleLogoChange} />
                      </label>
                      <div className="text-muted fs-11">
                        Allowed JPG, GIF, or PNG. <br />Maximum File Size: 1MB
                      </div>
                    </div>
                  </div>
                </div>
                <hr className="my-3" />
                <div className="mb-3 col-md-6">
                  <label htmlFor="organization" className="form-label">Studio/Company Name<span style={{ color: "red", marginLeft: "4px" }}>*</span></label>
                  <input type="text" className="form-control" id="organization" name="organization" value={studioName} placeholder="Enter Your company/studio Name" onChange={(e) => setStudioName(e.target.value)} />
                  {errors.studioName && <div style={{ color: 'red' }}>{errors.studioName}</div>}
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="email" className="form-label">E-mail</label>
                  <input className="form-control" type="text" id="email" name="email" value={email} placeholder="Enter Your Email Address " onChange={(e) => setEmail(e.target.value)} />
                  {emailError && <div style={{ color: 'red' }}>{emailError}</div>}

                </div>

                <div className="mb-3 col-md-6">
                  <label className="form-label" htmlFor="contactNo">Contact Number<span style={{ color: "red", marginLeft: "4px" }}>*</span></label>
                  <input
                    type="text"
                    id="contactNo"
                    name="contactNo"
                    className="form-control"
                    placeholder="Enter your contact number"
                    value={contactNo}
                    onChange={(e) => setContactNo(e.target.value)}
                    pattern="[0-9]*"
                    inputMode="numeric"
                    onInput={(e) => {
                      if (e.target.value.length > 10) {
                        e.target.value = e.target.value.slice(0, 10);
                      }
                    }}
                    maxLength="10"
                  />
                  {contactNoError && <div style={{ color: 'red' }}>{contactNoError}</div>}
                  {errors.contactNo && <div style={{ color: 'red' }}>{errors.contactNo}</div>}
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="webiste" className="form-label">Website</label>
                  <input type="text" className="form-control" id="webiste" name="webiste"
                    placeholder="Enter Your Website" value={website} onChange={(e) => setWebsite(e.target.value)} />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="addressLine1" className="form-label">
                    Address Line 1
                  </label>
                  <textarea
                    className="form-control"
                    id="addressLine1"
                    name="addressLine1"
                    placeholder="Enter Address Line 1"
                    rows="2"
                    maxLength="500"
                    value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="addressLine2" className="form-label">
                    Address Line 2
                  </label>
                  <textarea
                    className="form-control"
                    id="addressLine2"
                    name="addressLine2"
                    placeholder="Enter Address Line 2"
                    rows="2"
                    maxLength="500"
                    value={addressLine2}
                    onChange={(e) => setAddressLine2(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="city" className="form-label">
                    City
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="city"
                    name="city"
                    placeholder="Enter Your City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="state" className="form-label">
                    State
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                    placeholder="Enter Your State"
                    value={state}
                    onChange={(e) => setState(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="state" className="form-label">
                    Country
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="country"
                    name="Country"
                    placeholder="Enter Your Country"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="pinCode" className="form-label">
                    Postal Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="pinCode"
                    name="pinCode"
                    placeholder="Enter Your Postal Code"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                  />
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="locationurl" className="form-label">Location URL</label>
                  <input className="form-control" type="text" id="locationurl" name="locationurl" placeholder="Enter Studios Google Map Url "
                    value={locationUrl} onChange={(e) => setLocationUrl(e.target.value)} />
                </div>


                <div className="mb-3 col-md-6">
                  <label htmlFor="Facebook" className="form-label">Facebook</label>
                  <input className="form-control" type="text" id="Facebook" name="Facebook" placeholder="Enter Your Facebook Link" value={facebook} onChange={(e) => setFacebook(e.target.value)} />
                </div>

                <div className="mb-3 col-md-6">
                  <label htmlFor="twitter" className="form-label">Twitter</label>
                  <input className="form-control" type="text" id="twitter" name="twitter" placeholder="Enter Your Twitter Link" value={twitter} onChange={(e) => setTwitter(e.target.value)} />
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="Instagram" className="form-label">Instagram</label>
                  <input className="form-control" type="text" id="Instagram" name="Instagram" placeholder="Enter Your Instagram Link" value={instagram} onChange={(e) => setInstagram(e.target.value)} />
                </div>
                <div className="mb-3 col-md-6">
                  <label htmlFor="youtube" className="form-label">Youtube</label>
                  <input className="form-control" type="text" id="youtube" name="youtube" placeholder="Enter Your Youtube Link" value={youtube} onChange={(e) => setYoutube(e.target.value)} />
                </div>

              </div>
              <div className="mt-2">
                <button type="submit" className="btn btn-primary me-2">Save</button>
                <button type="button" className="btn btn-secondary me-2" onClick={handleCancel}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div>
        {imageFile && showCropperModal && (
          <ImageCropping
            imageFile={imageFile}
            onClose={handleModalClose}
            onCrop={handleCropSave}
            imageType={imageType}
          />
        )}
      </div>
    </div>
  )
}
